import { rootReducer, LATEST_SCHEMA_VERSION } from './reducers';
import rootEpic from './epics';
import { debug } from '../../utils';
const log = debug('app/models');

const loadState = () => {
	try {
		const serializedState = localStorage.getItem('state');
		if (serializedState === null) return null;
		const state = JSON.parse(serializedState)
		return (!state.schemaVersion || state.schemaVersion < LATEST_SCHEMA_VERSION) ? null : state
	} catch(err) {
		log(err)
		return null
	}
};

import throttle from 'lodash/throttle';
const SAVE_STATE_INTERVAL = 1000;
const saveState = throttle(state => {
	const { auth, profile, account, places, queries, userPosition } = state
	try {
		const serializedState = JSON.stringify({
			auth, profile, account, places, queries, userPosition
		})
		localStorage.setItem('state', serializedState);
	} catch(err) {
		log(err)
	}
}, SAVE_STATE_INTERVAL)

export { rootReducer, rootEpic, loadState, saveState, LATEST_SCHEMA_VERSION };



// WEBPACK FOOTER //
// ./src/app/models/index.ts